import { ArrowRight } from 'lucide-react'
import { TELEGRAM_BOT_URL } from '@/lib/constants'
import { useScrollReveal } from '@/hooks/useScrollReveal'

const SCREENSHOTS = [
  {
    src: '/app-dashboard.jpg',
    title: 'Dashboard principal',
    desc: 'El Top Pick del día, métricas de rendimiento y estado del sistema en tiempo real.',
  },
  {
    src: '/app-picks.jpg',
    title: 'Picks del día',
    desc: 'Vista de todos los picks generados por la IA con probabilidad, cuota y nivel de riesgo.',
  },
  {
    src: '/app-picks2.jpg',
    title: 'Historial de picks',
    desc: 'Cada pick queda registrado con su resultado — ganado o perdido, siempre visible.',
  },
  {
    src: '/app-parlays.jpg',
    title: 'Parlays inteligentes',
    desc: 'Combinaciones automáticas generadas por la IA con cuota combinada y simulador de ganancia.',
  },
  {
    src: '/app-dashboard2.jpg',
    title: 'Actividad reciente',
    desc: 'Resumen de picks recientes y estado de todos los motores de IA activos en el sistema.',
  },
]

export function AppScreenshots() {
  const ref = useScrollReveal<HTMLElement>()

  return (
    <section ref={ref} className="max-w-5xl mx-auto px-5 py-20">
      <div className="text-center mb-12 reveal">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand mb-2">
          La app por dentro
        </p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold">
          Así se ve por{' '}
          <span className="text-brand">dentro</span>
        </h2>
        <p className="mt-3 text-text-dim max-w-lg mx-auto text-sm leading-relaxed">
          Capturas reales de la Mini App de Telegram. Sin filtros, sin mockups genéricos.
          Esto es exactamente lo que ves cuando te registras.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SCREENSHOTS.map((s, i) => (
          <div
            key={s.src}
            className="reveal flex flex-col gap-3"
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            {/* Phone frame */}
            <div className="relative rounded-2xl overflow-hidden border border-border bg-panel group">
              <div className="absolute inset-0 bg-gradient-to-t from-bg/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />
              <img
                src={s.src}
                alt={s.title}
                loading="lazy"
                className="w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                style={{ maxHeight: '420px' }}
              />
            </div>
            <div>
              <h3 className="font-display text-lg font-bold text-brand">{s.title}</h3>
              <p className="text-sm text-text-dim leading-relaxed mt-1">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="cta-strip reveal" style={{ transitionDelay: '200ms' }}>
        <a href={TELEGRAM_BOT_URL} target="_blank" rel="noopener noreferrer" className="btn-brand">
          Acceder a la app gratis
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </section>
  )
}
